import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialBookingPageState,
  BookingItemData,
} from "../core/_model.booking";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedBooking = {
  data: BookingItemData | null;
  action: ActionsKey;
};

type BookingDataType = {
  bookingList: any;
  detail: BookingItemData | null;
  actioned: ActionedBooking | null;
  totalItems?: number;
  setDetail: (detail: BookingItemData | null) => void;
  setBookingList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedBooking | null) => void;
};

export const useBookingStore = create<BookingDataType>(
  (set) => ({
    bookingList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setBookingList: (saleData) =>
      set((state) => ({
        bookingList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useBookingListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialBookingPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
